import { render, staticRenderFns } from "./TissueForm.vue?vue&type=template&id=6b21871a"
import script from "./TissueForm.vue?vue&type=script&lang=js"
export * from "./TissueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports